module.exports = __webpack_public_path__ + "img/安卓-icon.50045916.svg";